import { LinearProgress } from "@material-ui/core";
import React from "react";
import { usePermissions } from "react-admin";
import { Redirect } from "react-router-dom";

const Dashboard = () => {
	const { permissions, loaded } = usePermissions();
	if (!loaded) {
		return <LinearProgress />;
	}
	const path = permissions("admin")
		? "/stats"
		: permissions("affiliate_manager")
		? "/users"
		: "/deals/1";
	return <Redirect to={path} />;
};

export default Dashboard;
